import { FC, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { DatePicker } from '@beeline/design-system-react/extracted-styles';

import { getRoomsState } from 'src/store/rooms/selectors';
import { roomsActions } from 'src/store/rooms/slice';
import { useAppDispatch } from 'src/store/useAppDispatch';
import { getDateTime } from 'src/utils/getDateTime';

export const RoomBookingDateField: FC = () => {
  const dispatch = useAppDispatch();
  const { backgroundData, date, dateError, town } = useSelector(getRoomsState);
  const { min, max } = useMemo(() => {
    const minDate = getDateTime({
      timezoneOffset: town?.timeZone,
    });
    minDate.setHours(0);
    minDate.setMinutes(0);
    minDate.setSeconds(0);
    minDate.setMilliseconds(0);
    const maxDate = new Date(minDate);
    maxDate.setDate(maxDate.getDate() + 60);

    return { min: minDate, max: maxDate };
  }, [town?.timeZone]);

  const dateDisabled = !backgroundData;

  const setDate = useCallback(
    (value: string | undefined) => {
      dispatch(roomsActions.setDate(value));
    },
    [dispatch],
  );

  return (
    <DatePicker
      label='Дата'
      minDate={min.toISOString()}
      maxDate={max.toISOString()}
      onChange={setDate}
      value={date}
      error={!!dateError}
      helperText={dateError}
      dataTestId='roomBookingDate'
      disabled={dateDisabled}
      fullWidth
    />
  );
};
